import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import httpInterceptor from "../../common/APIConfig";

/**
 * Async thunk to fetch VM status from API
 * @param {Object} payload
 * @param {string} payload.accountId - AWS account ID
 * @param {string} payload.vmId - VM ID
 */
export const getAWSDBStatus = createAsyncThunk(
  "AWSDBStatus/getAWSDBStatus",
  async ({ accountId, id, tag ,type}, { rejectWithValue }) => {
    try {
      // ✅ Replace with your actual API endpoint
      const response = await httpInterceptor.get(
        `/resources/aws/rds-poll?account=${accountId}&database=${id}&tag=${tag}&db_type=${type}`
      );

      // Example expected response:
      // { vmId: "i-1234567890", vmStatus: "running" }
      return response.data;
    } catch (error) {
      // Handle API error
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch VM status"
      );
    }
  }
);

const AWSDBStatusSlice = createSlice({
  name: "AWSDBStatus",
  initialState: {
    loading: false,
    statusResponse: null,
    error: false,
    errorMessage: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAWSDBStatus.pending, (state) => {
        state.loading = true;
        state.error = false;
        state.errorMessage = "";
      })
      .addCase(getAWSDBStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.statusResponse = action.payload;
      })
      .addCase(getAWSDBStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.errorMessage = action.payload;
      });
  },
});

export default AWSDBStatusSlice.reducer;
